<template>
    <div class="pim-product-table-list">
        <div class="pim-product-table-list__header">
            <div v-for="title in headers" class="pim-product-table-list__title">
                {{title}}
            </div>
        </div>
        <span class="row">
            <div class="pim-product-table-list__hr">
                <hr>
            </div>
        </span>

        <slot />
    </div>
</template>

<script>

export default {
    name: "pim-product-table-list",
    components: {},
    props: {
        headers: Array
    }
}

</script>
